import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"500px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createElementVNode("div", null, " Для расчета плана необходимо добавить исходные данные с используемыми грузами и транспортами. "),
  /*#__PURE__*/_createElementVNode("div", null, " Для запуска расчета нужно нажать кнопку «Рассчитать план». "),
  /*#__PURE__*/_createElementVNode("div", null, " После расчета станет активной вкладка «Результат» и появится кнопка «Отчет», позволяющая сгенерировать отчет по данному плану. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "Добавление грузов:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, " При добавлении рулонов/паллетов поля можно заполнить вручную или скопировать из справочников (см. справочники Рулоны и Паллеты) "),
    /*#__PURE__*/_createElementVNode("li", null, " Дополнительно надо задать количество используемых рулонов/паллетов "),
    /*#__PURE__*/_createElementVNode("li", null, " Также возможно задать Тоннаж (кг), тогда количество будет найдено исходя из веса груза. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Добавление транспорта:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, " При добавлении грузовых вагонов/контейнеров/автотранспорта поля можно заполнить вручную или скопировать из справочников (см. описание справочников Грузовые вагоны/Контейнеры/Автотранспорт) "),
    /*#__PURE__*/_createElementVNode("li", null, " Дополнительно надо задать количество используемых вагонов/контейнеров/авто. ")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "В таблице «Грузы» содержится информация о грузах:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "План – количество заданное в исходных данных"),
    /*#__PURE__*/_createElementVNode("li", null, "Загружено – количество задействованных грузов"),
    /*#__PURE__*/_createElementVNode("li", null, "Остаток – количество незадействованных грузов.")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Также для каждого типа есть подсуммировки по количеству и суммарному весу грузов. "),
  /*#__PURE__*/_createElementVNode("div", null, " В таблице «Транспорт» содержится информации о транспорте: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "План – количество заданное в исходных данных"),
    /*#__PURE__*/_createElementVNode("li", null, "Загружено – количество задействованного транспорта"),
    /*#__PURE__*/_createElementVNode("li", null, "Остаток – количество незадействованного транспорта.")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Также для каждого типа есть подсуммировки по количеству и суммарной грузоподъемности транспорта. "),
  /*#__PURE__*/_createElementVNode("div", null, " В таблице «Схемы погрузки» содержится информация о схемах погрузки. Таблица слева содержит список различных схем и количество транспорта. Справа подробная информация о схеме: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Название схемы с типом используемого транспорта"),
    /*#__PURE__*/_createElementVNode("li", null, " Количество транспорта, которых нужно погрузить по данной схеме "),
    /*#__PURE__*/_createElementVNode("li", null, "Список грузов и их количество для данной схемы"),
    /*#__PURE__*/_createElementVNode("li", null, "Общий вес груза и вместимость транспорта"),
    /*#__PURE__*/_createElementVNode("li", null, " Информация о продольном и поперечном смещениях и допустимых продольном и поперечном смещениях "),
    /*#__PURE__*/_createElementVNode("li", null, "Схематический вид погрузки, вид сверху.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: План",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DxTabPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, { title: "План" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, { title: "Исходные данные" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, { title: "Результат" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 512))
}